module.exports = __webpack_public_path__ + "img/setting.24519c7d.svg";